module.exports = "/_next/static/images/0e548c817a42f6fba78454964f2efb2b-credit-card-prepayment@0.75x.png.webp";